<ms-scroll-adapter [scrollSize]="100" [msScrollSelectedInView]="'selector-' + active">
    <div class="selectors-container">
        <button
            class="btn btn-primary add-to-betslip btn-unfocused"
            *ngFor="let selector of selectors"
            [attr.data-menu-item-id]="'selector-' + selector.value"
            (click)="addToBetslip(selector)">
            <span class="theme-add-betslip"></span>
            {{ selector.title }}
        </button>
    </div>
</ms-scroll-adapter>
